var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"desc"},[_vm._v("\n  系统检测到您当前转让的用户暂未绑定手机，无法进行该操作，请通知该用户前往\n  "),_c('Button',{attrs:{"type":"text","url":_vm.USER_CENTER_URL}},[_vm._v("个人中心")]),_vm._v("\n  进行绑定之后再重试\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }